var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedbackbtn",on:{"click":_vm.go_feedback}},[_c('img',{attrs:{"src":"/static/img/ucenter/feedback.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }